var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isPricingPayAsYouGo
    ? _c("BaseModal", {
        attrs: {
          id: _vm.id,
          modalClass: "modal-md",
          headerText: _vm.headerText,
          showCloseButton: false
        },
        on: { onClose: _vm.handleClose },
        scopedSlots: _vm._u(
          [
            {
              key: "body",
              fn: function() {
                return [
                  _c("div", { staticClass: "container-body" }, [
                    _c("div", { staticClass: "unit-price" }, [
                      _vm._v(_vm._s(_vm.bodyTextUnitPrice))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "per-month" }, [
                      _vm._v(_vm._s(_vm.bodyTextPerMonth))
                    ])
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "footer",
              fn: function() {
                return [
                  _c("div", { staticClass: "container-footer" }, [
                    _c("span", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://www.treesoft.io/" +
                              _vm.lang +
                              "/pricing",
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("button.learnmore")) +
                              "\n          "
                          ),
                          _c("i", { staticClass: "fas fa-external-link-alt" })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light btn-view-service-used",
                          attrs: { type: "button" },
                          on: { click: _vm.onClickViewServiceUse }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("button.viewserviceused")) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-web",
                          attrs: { type: "button" },
                          on: { click: _vm.onClickClose }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("button.close")) +
                              "\n        "
                          )
                        ]
                      )
                    ])
                  ])
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          3674119584
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01a613ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a613ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalOverLimit.vue
// module id = null
// module chunks = 